import { urlWithQuery } from '~/utils/url';
import { BaseRestRepository } from './baseRestRepository';
import type { AddCompanyPayoutsDto, CompanyPayoutPaginationDto, CompanyPayoutsDto, PayoutResultsDto } from '~/swagger/portal/Api';

const BASE_URL = '/api/payouts';

export type PayOutListFilter = {
  page?: number;
  pageSize?: number;
  unitIdOr?: string[];
  propertyIdOr?: string[];
  portfolioIdOr?: string[];
  vendorIdOr?: string[];
  'PayOutDate.Start'?: string;
  'PayOutDate.End'?: string;
  'Amount.From'?: number;
  'Amount.To'?: number;
};

export class PayOutsRepository extends BaseRestRepository {
  public async getPayOuts(filter?: PayOutListFilter): Promise<CompanyPayoutPaginationDto> {
    const url = urlWithQuery(BASE_URL, filter);
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async addPayOut(payload: AddCompanyPayoutsDto): Promise<PayoutResultsDto> {
    const url = `${BASE_URL}`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async deletePayOut(transferId: string) {
    const url = `${BASE_URL}/${transferId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }

  public async calculatePayOuts(): Promise<CompanyPayoutsDto> {
    const url = `${BASE_URL}/calculate`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }
}
